import { takeLatest, put, call, all } from "redux-saga/effects";
import CommentActionTypes from "./comment.types";
import { firestore } from "../../utils/firebase/firebase.util";
import {
  fetchCommentsSuccess,
  fetchCommentsFailure,
  createCommentSuccess,
  createCommentFailure,
  fetchCommentsStart,
} from "./comment.actions";

export function* fetchCommentsAsync({ payload }) {
  try {
    const commentRef = firestore.collection("kommentare");
    const query = commentRef.where("reportId", "==", payload);
    const snapshot = yield query.get();
    const transformedComments = yield snapshot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });
    yield put(fetchCommentsSuccess(transformedComments));
  } catch (error) {
    yield put(fetchCommentsFailure(error));
  }
}

export function* createCommentAsync({ payload }) {
  const comment = payload;
  try {
    yield firestore.collection("kommentare").add({ ...comment });
    yield put(fetchCommentsStart(comment.reportId));
    yield put(createCommentSuccess());
  } catch (error) {
    yield put(createCommentFailure);
  }
}

export function* onFetchComments() {
  yield takeLatest(CommentActionTypes.FETCH_COMMENTS_START, fetchCommentsAsync);
}

export function* onCreateComment() {
  yield takeLatest(CommentActionTypes.CREATE_COMMENT_START, createCommentAsync);
}

export function* commentSagas() {
  yield all([call(onFetchComments), call(onCreateComment)]);
}
